import QRCode from "qrcode";
import { useEffect, useRef } from "react";

const PrintRequestPage = ({
  formId,
  groupId,
  items,
  onDone,
  useNow = true,
  formNumber = "F-QP-STR-01-01 Rev.03",
}) => {
  const hasPrinted = useRef(false);

  useEffect(() => {
    if (hasPrinted.current) return;
    hasPrinted.current = true;

    const canvas = document.createElement("canvas");
    QRCode.toCanvas(canvas, groupId, { width: 120 }, (error) => {
      if (error) console.error(error);
      const dataUrl = canvas.toDataURL("image/png");

      const fmt = (n) => n == null ? "" : new Intl.NumberFormat("en-US").format(n);
      const itemRows = items
        .map(
          (item, index) => `
            <tr>
              <td><input type="checkbox" /></td>
              <td>${index + 1}</td>
              <td>${item.product_name}</td>
              <td>${fmt(item.stock_out)}</td>
              <td>${item.transaction_remark || ""}</td>
              <td>${item.transaction_for || ""}</td>
            </tr>`
        )
        .join("");

      const submittedDate = useNow
        ? new Date().toLocaleString()
        : items[0]?.transaction_modified
        ? new Date(items[0].transaction_modified).toLocaleString()
        : "N/A";
      const submittedBy = items[0]?.transaction_by || "N/A";

      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Request</title>
            <style>
              @page { size: A4; margin: 15mm; }
              body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
              table { width: 90%; margin: 20px auto; border-collapse: collapse; }
              th, td { border: 1px solid #ccc; padding: 8px; font-size: 14px; }
              th { background-color: #eee; }
              .table-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 90%;
                margin: 0 auto;
              }
              .table-header h2 {
                margin: 0;
              }
              img.qr {
                width: 3cm;   /* ~120px */
                height: 3cm;
              }
                .footer {
  width: 90%;
  margin: 40px auto 0 auto;
  text-align: right;
  font-size: 13px;
  color: #333;
}
              .signature-row {
                display: flex;
                justify-content: space-between;
                margin-top: 5px;
                width: 90%;
                margin-left: auto;
                margin-right: auto;
                text-align: left;
              }
              .signature-block { width: 45%; }
              .signature-line {
                border-bottom: 1px solid #000;
                width: 100%;
                height: 50px;
                margin-top: 30px;
              }
              .no-print { margin: 30px auto; }
              button {
                font-size: 20px;
                padding: 12px 24px;
                background-color: #007bff;
                color: white;
                border: none;
                border-radius: 6px;
                cursor: pointer;
              }
              button:hover { background-color: #0056b3; }
              @media print { .no-print { display: none; } }
            </style>
          </head>
         <body>
  <h1>MATERIAL REQUEST FORM</h1>
    <h2><strong>REQUEST NUMBER:</strong> ${formId}</h2>
  <h2><strong>ID:</strong> ${groupId}</h2>
  <div class="table-header">
    <h2><strong>Date:</strong> ${submittedDate}</h2>
    <img class="qr" src="${dataUrl}" alt="QR Code" />
  </div>

  <table>
    <thead>
      <tr>
        <th>✓</th>
        <th>No</th>
        <th>Product Name</th>
        <th>Qty</th>
        <th>Remark</th>
        <th>Customer</th>
      </tr>
    </thead>
    <tbody>
      ${itemRows}
    </tbody>
  </table>

  <div class="signature-row">
    <div class="signature-block">
      <p><strong>Approved By:</strong></p>
      <div class="signature-line"></div>
      <p style="margin-top: 5px;">(Signature)</p>
    </div>
    <div class="signature-block">
      <p><strong>Requested By:</strong> ${submittedBy}</p>
      <div class="signature-line"></div>
      <p style="margin-top: 5px;">(Signature)</p>
    </div>
  </div>

  <div class="no-print">
    <button onclick="window.print()">🖨️ Print This Page</button>
  </div>

  <!-- Tambahan Footer -->
  <div class="footer">
    <p>Form : <strong>${formNumber}</strong></p>
  </div>
</body>

        </html>
      `);
      printWindow.document.close();

      if (onDone) {
        setTimeout(() => onDone(), 500);
      }
    });
  }, [groupId, items, onDone, useNow, formNumber]);

  return null;
};

export default PrintRequestPage;
